/**
 * @group DOM Attribute
 */
export const USE_HISTORY = 'history-scroll';
